module["exports"] = [
  56,
  62,
  59
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/cell_phone/common_cell_prefix.js
// module id = 2089
// module chunks = 0